import React, { useEffect } from 'react';
import MegawideLogo from './images/MegawideLogo.png';
import RedAsset from './images/redassetmegawide.PNG';
import { Link, useHistory } from 'react-router-dom';

const Unknown = () => {
  const history = useHistory();
  useEffect(() => {
    setTimeout(() => {
      history.push('/');
    }, 5000);
  }, [history]);

  return (
    <div className="login-page">
      <div className="login-page-contents">
        <h2 className="login-page-title">
          404
          <br />
          Page not found{' '}
        </h2>
        <br />
        <div className="loginContainer">
          <div className="signin-content">
            <label>Redirecting you to home, or </label>
            <span><Link to="/">click here</Link></span>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        <img className="login-page-megawidelogo" src={MegawideLogo} alt="" />
        <div className="login-title-redline"></div>
        <h2 className="login-page-title">
          CHECK REQUEST <br />
          AND INQUIRY SYSTEM{' '}
        </h2>
        {/* <img style={{ position: 'absolute', top: 20, right: 50, height: '80px' }} src={AzureCloudLogo} alt="azure cloud logo" /> */}

        <img className="redAssetImg" src={RedAsset} alt="" />
      </div>
    </div>
  );
};

export default Unknown;
